import { WhatsNewItem } from './beehive.types';
import { DropdownFilterType } from './dropdownFilter.types';

export interface WhatsNewState {
	whatsNewItems: WhatsNewItem[];
	whatsNewHtml: string;
	iFrameUrl: string;
	lastWhatsNewVersionSeen: string | null;
	currentWhatsNewVersion: string;
	isLoading: boolean;
	whatsNewPageUrl: string;
	routeToReturnOnClose: string | undefined;
}

export interface CardEntity {
	// Title of the card.
	title: string;
	// Description of the new feature on the card.
	description: string;
	// The card usually clickable, this is the link to the page it will bring the user to.
	link: string;
	// Link to the thumbnail image/gif of the card.
	thumbnail?: string;
	// Tags on the card for filtering.
	tags: Array<string>;
	hasVideo: boolean;
}

/**
 * Structure of data for each section on the What's New page.
 */
export interface SectionEntity {
	// The title of the section
	title: string;
	// An array of all the cards in the section
	cards: Array<CardEntity>;
}

export interface WhatsNewPage {
	filters: DropdownFilterType[];
	sections: SectionEntity[];
}
